import React from "react";
import { Link } from "react-router-dom";
import {
    Container, Box, Card, Heading, Text, Badge, Separator, Inset
} from "@radix-ui/themes";
import { motion } from "framer-motion";

function AboutPage() {
    return (
        <Box>
            {/* Drevený pás hore (bez wood-line pod navbarom – ten ostáva vypnutý len na úvodnej) */}
            <section className="about-woodbar">
                <Container size="3" className="text-center">
                    <Heading size="8" className="text-white">O nás</Heading>
                    <Text size="3" className="text-white-50">kto sme a prečo to robíme</Text>
                </Container>
            </section>

            <Container size="3" className="my-5 container">
                <div className="row g-4 align-items-stretch">
                    {/* Obrázok / vizuál */}
                    <div className="col-lg-6 d-none d-lg-block">
                        <Card>
                            <Inset clip="padding-box" side="all">
                                <motion.img
                                    src="/images/about-image.jpg"
                                    alt="Drevené hodiny"
                                    className="about-hero-image"
                                    initial={{ opacity: 0, y: 12, scale: 0.98 }}
                                    animate={{ opacity: 1, y: 0, scale: 1 }}
                                    transition={{ duration: 0.55, ease: "easeOut" }}
                                />
                            </Inset>
                        </Card>
                    </div>

                    {/* Citát a text */}
                    <div className="col-lg-6">
                        <Card>
                            <Box p="4">
                                <div className="d-flex align-items-center gap-2 mb-2">
                                    <i className="bi bi-quote about-quote-icon"></i>
                                    <Badge color="brown" variant="soft">náš príbeh</Badge>
                                </div>

                                <Heading size="6" mb="2">MČ Wood Design</Heading>

                                <Text as="p" className="about-quote">
                                    ,,Rodinnú firmu MČ Wood Design som založil v januári 2024. Moja vášeň pre prácu s drevom ma priviedla
                                    k rozhodnutiu pretaviť ju do vlastnej tvorby a prinášať originálne kúsky, ktoré majú zmysel a hodnotu.
                                    Najviac sa venujem výrobe nástenných hodín s rôznymi motívmi, vzormi a nápismi. Každý kus vyrábam s
                                    dôrazom na detail, kvalitu a praktickosť, aby bol nielen užitočný, ale aj estetickým doplnkom vášho
                                    domova. Okrem nástenných hodín vyrábam aj drevené krížiky, motýliky, ozdobné drevené plakety, či mnoho
                                    ďalších originálnych výrobkov.”
                                </Text>

                                <Text as="p" weight="bold" className="mb-0">— Martin Čiak, zakladateľ</Text>
                            </Box>
                        </Card>
                    </div>
                </div>

                <Separator size="4" my="5" />

                {/* Naše hodnoty */}
                <Heading size="5" mb="3">Čo u nás nájdete</Heading>
                <div className="row g-3">
                    <div className="col-12 col-md-6 col-lg-3">
                        <Card className="h-100">
                            <Box p="3">
                                <div className="d-flex align-items-center gap-2 mb-2">
                                    <i className="bi bi-brush about-icon"></i>
                                    <Heading size="3">Ručná práca</Heading>
                                </div>
                                <Text color="gray">Každý kus je vyrábaný s citom pre detail.</Text>
                            </Box>
                        </Card>
                    </div>

                    <div className="col-12 col-md-6 col-lg-3">
                        <Card className="h-100">
                            <Box p="3">
                                <div className="d-flex align-items-center gap-2 mb-2">
                                    <i className="bi bi-tree about-icon"></i>
                                    <Heading size="3">Prírodné materiály</Heading>
                                </div>
                                <Text color="gray">Drevo s jedinečnou textúrou a charakterom.</Text>
                            </Box>
                        </Card>
                    </div>

                    <div className="col-12 col-md-6 col-lg-3">
                        <Card className="h-100">
                            <Box p="3">
                                <div className="d-flex align-items-center gap-2 mb-2">
                                    <i className="bi bi-heart about-icon"></i>
                                    <Heading size="3">Poctivá kvalita</Heading>
                                </div>
                                <Text color="gray">Trvácne a praktické kúsky do vášho domova.</Text>
                            </Box>
                        </Card>
                    </div>

                    <div className="col-12 col-md-6 col-lg-3">
                        <Card className="h-100">
                            <Box p="3">
                                <div className="d-flex align-items-center gap-2 mb-2">
                                    <i className="bi bi-stars about-icon"></i>
                                    <Heading size="3">Originalita</Heading>
                                </div>
                                <Text color="gray">Motívy, vzory a nápisy na mieru.</Text>
                            </Box>
                        </Card>
                    </div>
                </div>

                {/* CTA */}
                <div className="d-flex gap-2 mt-4">
                    <Link to="/ponuka" className="btn btn-brown">Pozrieť ponuku</Link>
                    <Link to="/kontakt" className="btn btn-outline-secondary rounded-pill">Kontakt</Link>
                </div>
            </Container>
        </Box>
    );
}

export default AboutPage;
